<template>
	<div>
		<slot v-if="!confirming && !deleting"></slot>
		<a v-show="canDelete" href :key="`trash-${ key }`" @click.prevent="onClick" :class="buttonClasses" aria-label="Delete Resource"><div class="hover-title">{{ content }}</div><span class="fa" :class="icon"></span></a>
		<a v-show="confirming && !deleting" href @click.prevent="cancel" class="button" :class="aClass" aria-label="Cancel Delete Resource"><div class="hover-title">Cancel</div><span class="fa fa-undo"></span></a>
	</div>
</template>

<script>

export default {

	props: {
		icon: {
			type: String,
			default: 'fa-trash',
		},

		text: {
			type: String,
			default: 'Delete',
		},

		confirmText: {
			type: String,
			default: 'Confirm',
		},

		confirmedText: {
			type: String,
			default: 'Deleting...',
		},

		canDelete: {
			type: Boolean,
			default: true,
		},

		aClass: String,
	},

	data() {
		return {
			confirming: false,
			deleting: false,
			key: Math.random(),
		};
	},

	computed: {

		content() {
			if (this.deleting) return this.confirmedText;

			if (this.confirming) return this.confirmText;

			return this.text;
		},

		buttonClasses() {
			const classes = [];

			classes.push('button');

			if (!this.confirming && !this.deleting) classes.push('confirm-delete');

			if (this.aClass) {
				classes.push(this.aClass);
			}

			return classes.join(' ');
		},

	},

	methods: {

		onClick() {
			if (this.deleting) return;

			if (!this.confirming) {
				this.confirming = true;
				return;
			}

			this.deleting = true;
			this.confirming = false;

			this.$emit('deleted', () => {
				this.deleting = false;
			});

			setTimeout(() => {
				this.deleting = false;
			}, 5000);
		},

		cancel() {
			this.confirming = false;
		}
	},

};

</script>
